/*
 * PanamaJack — Devoluciones i18n: asigna al enlace #urldevolucion la URL del portal de
 * devoluciones correcto segun mercado+idioma (16 mercados x es/en/de), abre en _blank, y
 * traduce el widget de baja de Seguno (/unsubscribe). Incluye el cierre del popup de devoluciones.
 * Extraido de theme.js durante el rebase a Showcase 10.2.0 (iso-funcional).
 * Requiere jQuery (theme.jQuery / jQuery) y las globales currentMercado / currentLanguageISO
 * (definidas en layout/theme.liquid L110-111).
 */
(function () {
  var $ = (window.theme && window.theme.jQuery) || window.jQuery;
  if (!$) return;

    $(document).ready(function() {
    
    var url = window.location.href; // Obtener la URL completa
    var lastWord = url.split('/').pop();

    
    if(lastWord == 'unsubscribe'){
      
      if(currentLanguageISO == 'en'){
        $('.__seguno-unsubscribed-header').text('See you soon!');
        $('.__seguno-unsubscribed-text').text('Come back anytime');
        $('.__seguno-unsubscribed-button-container .__seguno-unsubscribed-button').text('Continue browsing');
      }else if(currentLanguageISO == 'de'){
        $('.__seguno-unsubscribed-header').text('Bis Bald!');
        $('.__seguno-unsubscribed-text').text('Komme gerne jederzeit zurück');
        $('.__seguno-unsubscribed-button-container .__seguno-unsubscribed-button').text('Browse weiter');
      }else if(currentLanguageISO == 'nl'){
        $('.__seguno-unsubscribed-header').text('Tot ziens!');
        $('.__seguno-unsubscribed-text').text('Kom op elk moment terug');
        $('.__seguno-unsubscribed-button-container .__seguno-unsubscribed-button').text('Blijf bladeren');
      }
      
    }
    
        
    var link = $('#urldevolucion'); // Usar jQuery para seleccionar el elemento
    link.attr('target', '_blank');
   
    if (currentMercado == 'ES') {
      if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajack.es/devoluciones");
      }else if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajack.es/en/returns");
      }
    } else if (currentMercado === 'DE') {
      if(currentLanguageISO == 'de'){
        link.attr('href', "https://returns.panamajack.de/ruecksendungen");
      }else if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajack.de/en/returns");
      }else if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajack.de/ruecksendungen");
      }
    } else if (currentMercado === 'AT') {
      if(currentLanguageISO == 'de'){
        link.attr('href', "https://returns.panamajack.at/ruecksendungen");
      }else if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajack.at/en/returns");
      }else if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajack.at/ruecksendungen");
      }
          
    } else if (currentMercado === 'BE') {
      if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajack.be/en/returns");
      }else if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajack.be/en/returns");
      }
          
    } else if (currentMercado === 'DK') {
      if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajack.dk/returns");
      }else if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajack.dk/returns");
      }
          
    } else if (currentMercado === 'FI') {
      if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajack.fi/returns");
      }else if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajack.fi/returns");
      }
          
    } else if (currentMercado === 'FR') {
      if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajack.fr/returns");
      }else if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajack.fr/returns");
      }
          
    } else if (currentMercado === 'NL') {
      if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajack.nl/en/returns");
      }else if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajack.nl/en/returns");
      }
      
          
    } else if (currentMercado === 'HU') {
      if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajack.hu/returns");
      }else if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajack.hu/returns");
      }
          
    } else if (currentMercado === 'IE') {
      if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajack.ie/returns");
      }else if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajack.ie/returns");
      }
          
    } else if (currentMercado === 'IT') {
      if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajack.it/returns");
      }else if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajack.it/returns");
      }
          
    } else if (currentMercado === 'LU') {
      if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajack.lu/returns");
      }else if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajack.lu/returns");
      }
          
    } else if (currentMercado === 'PL') {
      if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajack.pl/returns");
      }else if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajack.pl/returns");
      }
          
    } else if (currentMercado === 'PT') {
      if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajack.pt/returns");
      }else if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajack.pt/returns");
      }
          
    } else if (currentMercado === 'CZ') {
      if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajackshop.com/cz/en/returns");
      }else if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajackshop.com/cz/en/returns");
      }
          
    } else if (currentMercado === 'SE') {
      if(currentLanguageISO == 'en'){
        link.attr('href', "https://returns.panamajack.se/returns");
      }else if(currentLanguageISO == 'es'){
        link.attr('href', "https://returns.panamajack.se/returns");
      }
          
    }
  });

  $('#cerrarpopupDevoluciones').click(function() {
  $('#popupDevoluciones').fadeOut(300);
  $('#negropopupDevoluciones').fadeOut(300);
});
})();
